import React from 'react'

type Props = {
  children: React.ReactNode
}

const HeaderRow = ({ children }: Props) => {
  return (
    <thead>
      <tr>
        {children}
      </tr>
    </thead>
  )
}

export default HeaderRow
